import { createAction } from 'redux-act';
import { ICountry } from '../types';

export const fetchCountriesAction = createAction();
export const fetchCountriesSuccessAction = createAction<ICountry[]>();
